import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withHookForUser, withUpdateUser } from "src/modules/user/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateUser } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await updateUser(values);
        router.push("/user");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
        />
    );
};

export default compose(withHookForUser, withUpdateUser)(Edit);
